export enum createCompanyDepartmentFormFields {
  name = 'name',
  description = 'description',
}
